import { IGeographyPointLocation, IMealPeriod } from "@dining/api-client";
import { Body1, Button, Card, Link, MessageBar, MessageBarBody, Spinner, Title3 } from "@fluentui/react-components";
import classNames from "classnames";
import React from "react";
import { useSelector } from "react-redux";
import { syncCafeStatus } from "../common/commonConstants";
import * as diningReducer from "../reducers/diningReducer";
import * as diningSelector from "../selectors/diningSelector";
import { useAppDispatch } from "../store/store";
import mainStyles from "../styles/content.module.css";
import styles from "../styles/resyncCafe.module.css";
import CafeSyncSelector from "./CafeSelector/CafeSyncSelector";
import Disclaimer from "./CafeSync/Disclaimer";
import GettingStarted from "./GettingStarted";
import HoursOfOperation from "./HoursOfOperation/HoursOfOperation";
export type UpdateSyncCafeFormFields = {
  cafeRegion: string;
  cafeCountry: string;
  cafeLocation: string;
  cafeName: string;
  mealPeriods: IMealPeriod[];
  currencyName: string;
  currencySymbol: string;
  cafeDisclaimer: string;
  location: IGeographyPointLocation;
};
export default () => {
  const dispatch = useAppDispatch();
  const selectedSyncCafe = useSelector(diningSelector.syncCafeSelector);
  const syncCafeAndFlushCache = useSelector(diningSelector.syncCafeAndFlushCache);
  const syncAuthorizationFailure = useSelector(diningSelector.syncAuthorizationFailure);
  const isDisabled = syncCafeAndFlushCache === syncCafeStatus.PROGRESS || syncAuthorizationFailure;
  const handleResync = () => {
    dispatch(diningReducer.resetSyncCafeAndFlushCacheStatus(syncCafeStatus.PROGRESS));
    if (selectedSyncCafe) {
      dispatch(diningReducer.syncCafeAndFlushCacheByIdAsync(selectedSyncCafe.id));
    }
  };
  return (
    <div className={mainStyles.mainContainer}>
      {/* LEFT PANEL */}
      {/* comment these 2 lines flexShrink ,minWidthif you want width to be fixed */}
      <div className={mainStyles.leftPanel}>
        <CafeSyncSelector />
      </div>

      {/* RIGHT CONTENT AREA */}
      {selectedSyncCafe ? (
        <div className={classNames(styles.resyncCafeContent, styles.pageContainer)}>
          {/* Resync Section */}
          <Card className={styles.sectionCard}>
            {syncAuthorizationFailure && (
              <MessageBar intent="error" layout="multiline">
                <MessageBarBody>
                  You do not have authorization to perform this action. Please reach out to{" "}
                  <Link href="mailto:dwdining@microsoft.com" appearance="subtle">
                    dwdining@microsoft.com
                  </Link>{" "}
                  if you believe this is a mistake.
                </MessageBarBody>
              </MessageBar>
            )}

            {syncCafeAndFlushCache === syncCafeStatus.ERROR && (
              <MessageBar intent="error" layout="singleline">
                <MessageBarBody>
                  Resync for <b>{selectedSyncCafe.name}</b> Failed.
                </MessageBarBody>
              </MessageBar>
            )}

            {syncCafeAndFlushCache === syncCafeStatus.SUCCESS && (
              <MessageBar intent="success" layout="singleline">
                <MessageBarBody>
                  Resync for <b>{selectedSyncCafe.name}</b> complete.
                </MessageBarBody>
              </MessageBar>
            )}

            {syncCafeAndFlushCache === syncCafeStatus.PROGRESS && !syncAuthorizationFailure && (
              <div className={styles.progressBarStyle}>
                <table>
                  <tbody>
                    <tr>
                      <td className={styles.spinnerStyle}>
                        <Spinner size="small" />
                      </td>
                      <td className={styles.syncTextStyle}>
                        Resync in progress. Please do not close or refresh this page.
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            )}

            <Title3>Resync</Title3>
            <Body1 block>Do you want to resync this cafe&apos;s menu?</Body1>
            <div style={{ display: "flex", justifyContent: "flex-start" }}>
              <Button appearance="primary" onClick={handleResync} disabled={isDisabled}>
                Resync
              </Button>
            </div>
          </Card>

          {/* HOURS SECTION */}
          <Card className={styles.sectionCard}>
            <HoursOfOperation />
          </Card>

          {/* DISCLAIMER SECTION */}
          <Card className={styles.sectionCard}>
            <Disclaimer />
          </Card>
        </div>
      ) : (
        <GettingStarted instructions="Then you can resync the cafe menu or edit the hours of operation and disclaimer." />
      )}
    </div>
  );
};
